<template>
  <v-alert
    outlined
    text
    class="mb-0 body-2"
    color="info"
    :class="$root.mobile ? 'pa-2' : 'pa-4'"
  >
    Although you may pick a property to apply your approval will be good for any
    of our featured properties in the price range that you qualify for. You are
    not obligated to stick with the home on your application and can view others
    upon approval. Upon being pre-approved you will have an immediate option to
    move into any of our featured properties. If one of those does not work,
    your pre-approval will allow us to set up showings to view other homes
    listed on our site. <br />
    As you will see by browsing our website we work with many great landlords
    that offer a wide range of housing options in the Indianapolis area. We
    streamline the moving process as we eliminating the frustration of getting
    in contact with multiple agencies to schedule showings. We also negotiate
    with other landlords and management companies on your behalf. You will be
    represented by a Realtor who has been working in the Indy leasing market for
    over 10 years. We provide a personalized level of service for renters that
    traditionally is only available to individuals purchasing a home. There may
    be additional application fees on properties not managed by Alpine and
    processing time on those applications may vary. Completion of this
    application will serve as an agreement that you have read and understand
    this information.
  </v-alert>
</template>

<script>
export default {
  data() {
    return {
      alert: true,
    };
  },
};
</script>

<style></style>
